let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ey6b4")).then(() => parcelRequire('lINOD'));